import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

const useAutocompleteStyles = makeStyles(() => ({
  root: {
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"]': tw`p-0 flex-wrap-reverse`,
    '& .MuiFilledInput-underline:before': tw`border-0`,
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"] .MuiAutocomplete-input': {
      ...tw`py-3 pr-8 w-full`,
    },
    '& .MuiFilledInput-root.Mui-focused': tw`bg-white`,
    '& .MuiFilledInput-underline:after': tw`border-0`,
  },
  input: {
    '&': {
      ...tw`placeholder-gray-700 flex items-center relative border border-gray-500 border-solid border-opacity-25 px-2 bg-grey-500 bg-opacity-5 w-full h-full rounded-2xl`,
      'font-family': 'inherit',
    },
    textIndent: '1rem',
  },
  inputRoot: {
    '&:hover, &:focus, &:active': tw`bg-white`,
    '&': { ...tw`bg-white py-3`, 'font-family': 'inherit' },
  },
}));

export default useAutocompleteStyles;
